class ProductComparison extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return super.requiredElements.concat(['dot'])
  }

  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.5,
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.md +
            1}px)`]: {
            disabled: true,
          },
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useDots(
          this.els.dot.elements,
          (carousel, dot, index) => {
            const amountOfSlides = carousel.slides.length
            const slidesPerView = carousel.options.slides.perView
            const shouldHideDot = index >= amountOfSlides - (slidesPerView - 1)

            dot.setAttribute('aria-hidden', shouldHideDot.toString())
          },
        ),
      ],
    )
  }
}

if (!customElements.get('product-comparison')) {
  customElements.define('product-comparison', ProductComparison)
}
